// components/settings/NotificationSettings.jsx
import { useState } from "react";
import { useTranslation } from "react-i18next"; // ← اضافه شده

const NotificationSettings = ({ initialData }) => {
  const { t } = useTranslation(); // ← اضافه شده
  const [email, setEmail] = useState(initialData.email);
  const [sms, setSms] = useState(initialData.sms);
  const [whatsapp, setWhatsapp] = useState(initialData.whatsapp);

  const handleSave = () => {
    // TODO: send to backend
    console.log("Saved:", { email, sms, whatsapp });
  };

  return (
    <section className="bg-white rounded-xl shadow p-4 space-y-4">
      <h2 className="text-lg font-semibold text-gray-800">{t('notification_settings.title')}</h2>
      <div className="space-y-3 text-sm text-gray-700">
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={email}
            onChange={(e) => setEmail(e.target.checked)}
          />
          {t('notification_settings.receive_email')}
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={sms}
            onChange={(e) => setSms(e.target.checked)}
          />
          {t('notification_settings.receive_sms')}
        </label>
        <label className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={whatsapp}
            onChange={(e) => setWhatsapp(e.target.checked)}
          />
          {t('notification_settings.receive_whatsapp')}
        </label>
      </div>
      <button
        onClick={handleSave}
        className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 text-sm"
      >
        {t('notification_settings.save_button')}
      </button>
    </section>
  );
};

export default NotificationSettings;